import { getFreeRequest } from '~/services/http-requests'

enum BeatFileType {
    Mp3 = 'MP3',
    Wav = 'WAV',
    Trackout = 'Trackout'
}

/*
 **** GET ****
 */
async function getBeatDownloadUrl(beatId: IBeat['id'], fileType: BeatFileType): Promise<string> {
    const { url } = await getFreeRequest({ fullUrl: `/s3/beat_download_link/${beatId}/${fileType}/` })
    return url
}

export { BeatFileType, getBeatDownloadUrl }
